import {
  GradeStatsOverview,
  LessonGradesByCategoryItem,
  LessonGradesByClassItem,
  LessonGradesByMonthItem,
  PeriodGradesByCategoryItem,
  PeriodGradesByClassItem,
  PeriodGradesByGradingPeriodItem,
} from '@/types/grade-stats.types';
import { axios } from '@/lib/axios';

const PATH = '/api/account/grades';

type DateRangeParams = { fromMonth: string; toMonth: string };

const getOverview = async (params: DateRangeParams) => {
  const response = await axios.get<GradeStatsOverview>(`${PATH}/overview`, { params });
  return response.data;
};

const getLessonGradesByClass = async (params: DateRangeParams) => {
  const response = await axios.get<LessonGradesByClassItem[]>(`${PATH}/lesson-grades/by-class`, {
    params,
  });
  return response.data;
};

const getLessonGradesByMonth = async (params: DateRangeParams) => {
  const response = await axios.get<LessonGradesByMonthItem[]>(`${PATH}/lesson-grades/by-month`, {
    params,
  });
  return response.data;
};

const getPeriodGradesByClass = async (params: DateRangeParams) => {
  const response = await axios.get<PeriodGradesByClassItem[]>(`${PATH}/period-grades/by-class`, {
    params,
  });
  return response.data;
};

const getLessonGradesByCategory = async (params: DateRangeParams) => {
  const response = await axios.get<LessonGradesByCategoryItem[]>(
    `${PATH}/lesson-grades/by-category`,
    {
      params,
    }
  );
  return response.data;
};

const getPeriodGradesByGradingPeriod = async (params: DateRangeParams) => {
  const response = await axios.get<PeriodGradesByGradingPeriodItem[]>(
    `${PATH}/period-grades/by-grading-period`,
    {
      params,
    }
  );
  return response.data;
};

const getPeriodGradesByCategory = async (params: DateRangeParams) => {
  const response = await axios.get<PeriodGradesByCategoryItem[]>(
    `${PATH}/period-grades/by-category`,
    {
      params,
    }
  );
  return response.data;
};

const GradeStatsService = {
  getOverview,
  getLessonGradesByClass,
  getLessonGradesByMonth,
  getPeriodGradesByClass,
  getLessonGradesByCategory,
  getPeriodGradesByGradingPeriod,
  getPeriodGradesByCategory,
};

export default GradeStatsService;
